import { Icon as AntdIcon, type IconProps } from '@ant-design/react-native';
import { cssInterop } from 'nativewind';
import type { GestureResponderEvent } from 'react-native';

cssInterop(AntdIcon, {
    className: {
        target: 'style',
    },
});

export const Icon = ({
    className,
    onPress,
    ...props
}: {
    className?: string;
    onPress?: (event: GestureResponderEvent) => void;
} & IconProps) => {
    return <AntdIcon className={className} onPress={onPress} {...props} />;
};

export default Icon;